import { Link } from "react-router-dom";
import Button from "../../Components/Common/Button";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-6 text-center">
      <h1 className="text-6xl font-bold text-[#2A4258]">404</h1>
      <p className="text-xl text-gray-700 mt-4">
        Oops! The page you’re looking for doesn’t exist.
      </p>
      <Link to="/" className="mt-6">
        <Button type="primary">Go Back Home</Button>
      </Link>
    </div>
  );
};

export default NotFound;
